import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { MasterPage, IndexPage, LoginPage, RegistrationPage, SearchPage, FavoritesPage, PreferencesPage, NotifsPage, ProfilePage } from './pages'
import authentication from './http/auth'
import { store } from './reducers'
import 'bootstrap/dist/css/bootstrap.css'
import './index.css'

// RequireAuth component to protect routes
function RequireAuth({ children }) {
  const [isAuthenticated, setIsAuthenticated] = React.useState(null)

  React.useEffect(() => {
    authentication.isAuthenticated()
      .then(() => {
        store.dispatch({'type': 'LOGGED'})
        setIsAuthenticated(true)
      })
      .catch(() => {
        setIsAuthenticated(false)
      })
  }, [])

  if (isAuthenticated === null) {
    return <div>Loading...</div>
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

const container = document.getElementById('app-container')
const root = createRoot(container)
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MasterPage />}>
          <Route index element={<RequireAuth><IndexPage /></RequireAuth>} />
          <Route path="login" element={<LoginPage />} />
          <Route path="register" element={<RegistrationPage />} />
          <Route path="search" element={<RequireAuth><SearchPage /></RequireAuth>} />
          <Route path="favorites" element={<RequireAuth><FavoritesPage /></RequireAuth>} />
          <Route path="preferences" element={<RequireAuth><PreferencesPage /></RequireAuth>} />
          <Route path="notifs" element={<RequireAuth><NotifsPage /></RequireAuth>} />
          <Route path="profile" element={<RequireAuth><ProfilePage /></RequireAuth>} />
        </Route>
      </Routes>
    </BrowserRouter>
  </Provider>
)
